import type { IconData } from '@stacksjs/iconify-core'

export const emptyClipboard: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M29.114 3.049c1.75.036 3.07 1.58 2.864 3.318l-.234 1.984A3 3 0 0 1 28.765 11h-9.53a3 3 0 0 1-2.98-2.649l-.234-1.984c-.205-1.738 1.115-3.282 2.865-3.318c1.52-.031 3.22-.049 5.115-.049c1.894 0 3.592.018 5.113.049\"/><path d=\"M16.002 6.123c-2.71.092-4.776.223-6.31.352c-2.299.195-4.016 1.896-4.212 4.195C5.24 13.479 5 18.135 5 25.5c0 7.364.24 12.02.48 14.83c.196 2.299 1.913 4 4.213 4.194C12.479 44.76 17.026 45 24 45s11.521-.24 14.307-.476c2.3-.195 4.017-1.895 4.213-4.194c.24-2.81.48-7.466.48-14.83c0-7.365-.24-12.021-.48-14.83c-.196-2.3-1.913-4-4.213-4.195c-1.533-.13-3.6-.26-6.31-.352\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default emptyClipboard
